var _style, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stethoscope_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".stethoscope_svg__st3{fill:#35a4dd}.stethoscope_svg__st4{fill:none;stroke:#35a4dd;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.3 543.3v285.1s10.6 147.8 171.2 150.8c0 0 135.7 3.8 162.1-147.8V623.3S629.1 510.2 743 514"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 866.2,
    cy: 504.3,
    r: 101.2,
    fill: "none",
    stroke: "#f9af17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.4 8.8c-28.7 0-52 23.3-52 52s23.3 52 52 52 52-23.3 52-52c.1-28.7-23.2-52-52-52zM403.8 9.2c-28.7 0-52 23.3-52 52s23.3 52 52 52 52-23.3 52-52-23.3-52-52-52z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.4 62.6S60.1 49 56.7 155.4s47.1 259 47.1 259 37 120.7 135.7 125.2 134.2-4.5 134.2-4.5 61.8-7.5 99.5-98 53.5-143.3 59.6-267.7S404.8 62 404.8 62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default ForwardRef;